import React, {Component} from "react";
import {Buffer} from "buffer";
import {Button, Image, Form, Modal, Spin, Divider, Row, Col, Select, Upload} from "antd";
import {offerGeneralApiService} from "../../services/offer/OfferGeneralApiService";
import Cookies from "universal-cookie";
import {UploadOutlined} from "@ant-design/icons";

class UpdateDocumentGeneralOffer extends Component<any, any> {
    private readonly initState!: any;
    private user = JSON.parse(Buffer.from(new Cookies().get('_u'), "base64").toString())

    constructor(props: any) {
        super(props);
        this.initState = {
            dealerCode: "",
            offerCode: "",
            dataDetailStock: {},
            fetchingDetailOffer: false,
            documents: [],
            modalAddNewDoc: false,
            documentType: null,
            showUploadButton: false,
            submittingImage: false,
            newDocUrlImage: "",
        }
        this.state = {...this.initState}
    }

    async componentDidMount() {
        await this.promisedSetState({
            dealerCode: this.props.dealerCode,
            offerCode: this.props.offerCode,
            fetchingDetailOffer: true,
            showUploadButton: false,
            submittingImage: false,
            newDocUrlImage: "",
        });

        this.showOfferDetail();
    }

    async componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if (this.props.dealerCode !== prevProps.dealerCode) {
            console.log('diff dealer');
        }

        if (this.props.offerCode !== prevProps.offerCode) {
            await this.promisedSetState({
                offerCode: this.props.offerCode,
                fetchingDetailOffer: true,
            });
        }

        if (this.props.time !== prevProps.time) {
            this.showOfferDetail();
        }
    }

    addNewDocSave = async () => {
        if (!this.state.newDocUrlImage) {
            return Modal.error({title: 'Proses Gagal', content: 'Lakukan upload image terlebih dahulu'});
        }
        const listDoc = [...this.state.documents];
        listDoc.push({
            type: this.state.documentType,
            number: "newuplaoddoc",
            image: this.state.newDocUrlImage
        })
        await this.promisedSetState({documents: listDoc, modalAddNewDoc: false})
    }

    removeArrayDoc = async (removeIndex: number) => {
        const listDoc = [...this.state.documents];
        listDoc.splice(removeIndex, 1);
        await this.promisedSetState({documents: listDoc})
    }

    uploadImageChange = (data: any) => {
        if (data?.file?.status === "done") {
            console.log(data)
            const newImgLocation = data?.file?.response?.data?.document_asset?.[0]?.url;
            this.setState({submittingImage: false, newDocUrlImage: newImgLocation});
        }
        if (data?.file?.status === "uploading") {
            this.setState({
                submittingImage: true,
            });
        }
        if (data?.file?.status === "removed") {
            this.setState({
                submittingImage: false,
                newDocUrlImage: "",
            });
        }
    }

    showOfferDetail = async () => {
        let params: any = {
            offerCode: this.props.offerCode,
            companyCode: this.props.companyCode
        };

        try {
            const response = await offerGeneralApiService.getDetailOffer(params);
            const data = response.data.data;

            await this.promisedSetState({
                base64IdCardOwner: "",
                freezeStatus: false,
                dataDetailStock: data,
                documents: data?.document || [],
                fetchingDetailOffer: false,
            });
        } catch (error) {
            await this.promisedSetState({
                dataDetailStock: {},
                fetchingDetailOffer: false,
            });
        }
    }

    modalNewDoc = async () => {
        this.setState({
            modalAddNewDoc: true,
            documentType: null,
            showUploadButton: false,
            submittingImage: false,
            newDocUrlImage: "",
        })
    }

    onUpdateData = async () => {
        const dataUpdate = {
            update_type: "document-update",
            company: this.props.companyCode,
            offer_code: this.props.offerCode,
            documents: this.state.documents || []
        };

        await this.promisedSetState({updateProcess: true});
        try {
            await offerGeneralApiService.updateOffer(dataUpdate).then(successData => {
                Modal.success({title: 'Proses Sukses', content: 'Offer berhasil di update '});
                this.setState({updateProcess: false,});
                this.props.onCloseUpdateOwnerIdCardProps("close");
            });
        } catch (e) {
            Modal.error({title: 'Proses Gagal', content: 'Server Menolak Inputan Anda :' + e});
            await this.promisedSetState({updateProcess: false});
        }
    }

    onFieldChange = <T extends keyof Pick<any, "documentType">>(target: T, value: any) => {
        const currentState: any = {...this.state};
        switch (target) {
            case "documentType":
                currentState.documentType = value;
                if (!value) {
                    currentState.showUploadButton = false;
                } else {
                    currentState.showUploadButton = true;
                }
                break;
        }
        this.setState({
            ...currentState,
        });
    }


    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <>
                <div style={this.state.fetchingDetailOffer ? {} : {display: 'none'}} className={`spinCenter`}>
                    <Spin size="large"/>
                </div>
                <div style={!this.state.fetchingDetailOffer ? {} : {display: 'none'}}>
                    <Form layout="vertical">
                        <Form.Item>
                            <i className={`small-text-grey`}>Nama Lengkap</i><br/>{this.state.dataDetailStock?.id_card_owner?.full_name}
                        </Form.Item>
                        <Button onClick={() => this.modalNewDoc()} style={{margin: 10}} size={"small"}>Add New Document Image</Button>
                        <Row>
                            {this.state.documents?.map((item: any, i: number) =>
                                <Col key={i} span={8} style={{textAlign: "center"}}>
                                    <div style={{margin: 10}}>
                                        <span className={`col-grey-small-80`}>{item?.type === "registration" ? "STNK" : item?.type === "ownership" ? "BPKB" : item?.type === "notice" ? "notice" : item?.type}</span><br/>
                                        <Image style={{height: "60px"}} src={item?.image}/><br/>
                                        <Button onClick={() => this.removeArrayDoc(i)} style={{margin: 10}} danger={true} size={"small"}>remove</Button>
                                    </div>
                                </Col>
                            )}
                        </Row>

                    </Form>
                </div>
                <Divider/>
                <Button style={{float: "right"}} type={"primary"} loading={this.state.updateProcess} onClick={() => this.onUpdateData()}> Update Data</Button>

                <Modal
                    open={this.state.modalAddNewDoc}
                    title="Add New Document"
                    onCancel={() => this.setState({modalAddNewDoc: false})}
                    footer={[
                        <Button onClick={() => this.addNewDocSave()} loading={this.state.submittingImage} type={"primary"} key="0">Simpan Image</Button>,
                        <Button key="1" type="default" onClick={() => this.setState({modalAddNewDoc: false,})}>Tutup</Button>,
                    ]}
                >
                    <Form.Item className={"padTop-10"}>
                        <i className={`small-text-grey`}>Type Document</i>
                        <Select
                            showSearch
                            placeholder="Type Document"
                            optionFilterProp="children"
                            onChange={value => this.onFieldChange("documentType", value)}
                            value={this.state.documentType}
                        >
                            <Select.Option key={`registration`} value={`registration`}>{`registration - STNK`}</Select.Option>
                            <Select.Option key={`ownership`} value={`ownership`}>{`ownership - BPKB`}</Select.Option>
                            <Select.Option key={`notice`} value={`notice`}>{`notice`}</Select.Option>
                        </Select>

                        <div style={this.state.showUploadButton ? {marginTop: 20} : {display: 'none'}}>
                            <Upload
                                method="POST"
                                action={`https://hbxhwzeej9.execute-api.ap-southeast-1.amazonaws.com/v1/bpkb/upload/temp`}
                                listType="picture"
                                maxCount={1}
                                name="documents"
                                onChange={this.uploadImageChange}
                            >
                                <Button loading={this.state.submittingImage} icon={<UploadOutlined/>}>Upload Image Document</Button>
                            </Upload>
                        </div>

                    </Form.Item>
                </Modal>
            </>
        );
    }
}

export default UpdateDocumentGeneralOffer;
